import styled, { css } from "styled-components";
import * as Type from "../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { Backdrop } from "../../../../../common-deprecated/styles/v2/toyota/components/Backdrop";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Wrapper = styled.article`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    min-width: 150px;
    padding-right: 48px;

    html[dir="rtl"] & {
        padding-left: 48px;
        padding-right: 0;
    }
`;

export const Border = styled(Wrapper)<{ showCursorPointer?: boolean; hideBorder?: boolean }>`
    position: relative;
    justify-content: flex-start;
    cursor: ${({ showCursorPointer }) => (showCursorPointer ? "pointer" : "default")};

    ${Backdrop} {
        z-index: ${theme.zIndex.fixed};
    }
    &::after {
        display: ${({ hideBorder }) => (hideBorder ? "none" : "block")};
        position: absolute;
        right: -12px;
        width: 1px;
        height: 100%;
        content: "";
        background: ${theme.colors.grey2};
    }

    html[dir="rtl"] & {
        &::after {
            left: -12px;
            right: auto;
        }
    }
`;

export const ImageWrapper = styled.div`
    display: inline-block;
    width: 100px;
    height: 47px;
    @supports (object-fit) {
        object-fit: contain;
        object-position: center;
    }
`;

export const Title = styled.h3.attrs(() => ({
    className: "t-milli-text",
}))`
    width: 100%;
    margin-bottom: 0;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.5;
    color: ${theme.colors.primaryWhite};
    overflow: hidden;

    ${Type.Strong} {
        color: ${theme.colors.primaryWhite};
    }
`;

export const CarTitle = styled.div`
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-overflow: ellipsis;
    color: ${theme.colors.grey1};
    white-space: normal;
    overflow: hidden;
    /* stylelint-disable */
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    /* stylelint-enable */
`;

export const Subtitle = styled.h4.attrs(() => ({
    className: "t-milli-text",
}))`
    margin-bottom: 0;
    line-height: 2rem;
    text-overflow: ellipsis;
    color: ${theme.colors.primaryWhite};
    white-space: normal;
    overflow: hidden;
    /* stylelint-disable */
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    /* stylelint-enable */
`;

export const EngineNameTitle = styled.div.attrs(() => ({
    className: "t-milli-text",
}))`
    margin-bottom: 0;
    line-height: 2rem;
    text-overflow: ellipsis;
    color: ${theme.colors.grey4};
    white-space: normal;
    overflow: hidden;
    /* stylelint-disable */
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    /* stylelint-enable */
`;

export const CloseButton = styled.button`
    color: ${theme.colors.primaryWhite};
`;

export const IconHolder = styled.div`
    display: flex;
    position: absolute;
    top: 50%;
    right: ${theme.space[2]}px;
    align-items: flex-start;
    width: 24px;
    transform: translateY(-50%);
    cursor: pointer;

    .icon {
        padding: 0;
        line-height: 1;
    }

    html[dir="rtl"] & {
        left: ${theme.space[2]}px;
        right: auto;
    }
`;

export const Placeholder = styled.div<{ isLoading?: boolean }>`
    position: relative;
    margin: 0;
    overflow: hidden;

    &::before {
        height: 0;
        padding-top: 56.25%; /* Aspect ratio 16:9 */
        content: "";
    }

    img {
        width: auto;
        max-height: 100%;
    }

    svg {
        width: 100%;
        height: 100%;
        max-height: 128px;
        opacity: 0.125;
    }

    ${({ isLoading }) =>
        isLoading &&
        css`
            padding-top: 52%;
        `}
`;

export const PrevImage = styled.div<{ show?: boolean; transition?: string }>`
    transition: ${({ transition }) => transition};
    opacity: ${({ show }) => (show ? 1 : 0)};
`;
